import { SignUp } from "../../components";

const SignUpScreen = () => {
  return (
    <div>
      <SignUp/>
    </div>
  );
};

export default SignUpScreen;
